import ItemClassService from '@/services/admin/itemClass.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async getItemClasses({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemClassService.getItemClasses(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async showHideItemClassInWebQuote({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemClassService.showHideItemClassInWebQuote(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

}

const mutations = {
}

export const adminItemClass = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}